import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';
import { CrmChecksSideBarFilterType } from '../side-bar/crm-checks-side-bar-filter.type';
import { CrmPaymentChecksReportRow } from '../../../../../api/types/reports/crm/crm-payment-checks-report.type';

export const getReportCrmChecksOperation = async (
  filters: CrmChecksSideBarFilterType,
  offset: number,
  limit: number,
  setData: (data: CrmPaymentChecksReportRow[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const trimmedCheckReferenceId = filters.checkReferenceId?.trim();
    const res = await appApi.getCrmPaymentChecksReport({
      branchIds: filters.branchIds ?? [],
      includeUnassignedBranches: !!filters.includeUnassignedBranches,
      checkStatuses: filters.checkStatuses ?? [],
      paymentCollectionStartDate: filters.paymentCollectionStartDate ?? null,
      paymentCollectionEndDate: filters.paymentCollectionEndDate ?? null,
      checkRepaymentStartDate: filters.checkRepaymentStartDate ?? null,
      checkRepaymentEndDate: filters.checkRepaymentEndDate ?? null,
      docNumber: filters.docNumber ?? null,
      checkReferenceId: trimmedCheckReferenceId
        ? trimmedCheckReferenceId
        : null,
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
